import React from 'react'

export default ({loading}) => {
  return (
    <div className={`l-spinner ${loading ? 'l-spinner--loading' : ''}`}>
      <div className="l-spinner__el"></div>
    </div>
  )
}